module.exports = __webpack_public_path__ + "static/img/mr.Kenny.2468084.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/mr.Kenny.png
// module id = nqgy
// module chunks = 1